import { render, staticRenderFns } from "./CrossSellings.vue?vue&type=template&id=583c3650&scoped=true&"
import script from "./CrossSellings.js?vue&type=script&lang=js&"
export * from "./CrossSellings.js?vue&type=script&lang=js&"
import style0 from "./CrossSellings.scoped.scss?vue&type=style&index=0&id=583c3650&lang=scss&scoped=true&"
import style1 from "./CrossSellings.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c3650",
  null
  
)

export default component.exports